// 1. MUST BE THE VERY FIRST LINE

import './polyfills';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// VITE COMPATIBLE JQUERY GLOBAL ASSIGNMENT
import jQuery from 'jquery';
(window as any).$ = (window as any).jQuery = jQuery;
// Force bootstrap to find the jQuery we just set
import 'bootstrap';
declare var window: any;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if (window['ngRef']) {
    if (window['ngRef'] != undefined)
      window['ngRef'].destroy();
  }
  window['ngRef'] = ref;

  // Otherwise, log the boot error
}).catch(err => console.error(err));
